export default __webpack_public_path__ + "static/media/deliveryInWinaIcon.0544f868.jpg";